<template lang="pug">
v-container(fill-height pa-1 class=" tw-rounded tw-border-gray-lighten-2 " :key="key")
  v-row(no-gutters align="center" justify="space-between")
    template(v-if="!item.user")
      v-col(cols="auto")
        v-img(src="https://ui-avatars.com/api/?name=?&color=7F9CF5&background=EBF4FF" max-width="43" max-height="43")
      v-col(cols="stretch" class="pl-1")
        span(class="tw-capitalize") {{ $t('Opportunities.Common.unassigned') }}
    template(v-else)
      v-col(cols="auto")
        v-img(:src="item.user.profile_photo_url" max-width="43" max-height="43" class="tw-rounded-md")
      v-col(cols="stretch" class="pl-2")
        span {{ item.user.name }}
    v-col(cols="auto")
      v-menu(left ma-0 pa-0 nudge-bottom="50")
        template(v-slot:activator="{ on, attrs }")
          v-btn(
            small
            icon
            :ripple="false"
            depressed
            v-on="on"
            v-bind="attrs"
            color="white"
            class="pa-0 ma-0 tw-p-0 tw-m-0"
          )
            v-icon(color="blue-grey lighten-4") mdi-menu-down
        v-card(ma-1 class=" tw-w-56")
          v-card-text(class="pa-2")
            v-row
              v-col
                span(class="pl-3 tw-font-bold tw-text-lg") {{ $t('Opportunities.Common.assign') }}
            v-row(no-gutters class="pt-3")
              v-col
                div(v-for="member in members" :key="member.id" @click="assign(member.id)" class="tw-cursor-pointer tw-pb-1")
                  v-row(no-gutters align="center" class=" tw-border-gray-lighten-2 tw-rounded ")
                    v-col(cols="3")
                      v-img(:src="member.profile_photo_url" width="40px")
                    v-col(cols="auto")
                      span {{ member.name }}
</template>
<script>
export default {
  props: ['item_type', 'item'],
  data() {
    return {
      key: 0,
    };
  },
  computed: {
    members() {
      return this.$store.getters['team/members'];
    },
    user_id() {
      return this.item.user_id;
    },
  },
  watch: {
    item() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('team/getMembers');
      if (this.user_id) {
        this.$store.dispatch('user/getUserProfile', this.user_id).then((r) => {
          this.user = r;
        });
        this.key++;
      }
    },
    assign(memberId) {
      this.item.user_id = memberId;
      this.$store.dispatch(this.item_type + '/update', this.item).then(() => {
        this.$store.dispatch('user/getUserProfile', this.item.user_id).then((r) => {
          this.item.user = r;
        });
      });
    },
  },
};
</script>
